import React from 'react'
import Block1 from '../Main/Block1';
import Block2 from '../Main/Block2';
import Block3 from '../Main/Block3';
import Block4 from '../Main/Block4';
import Block5 from '../Main/Block5';
import Block6 from '../Main/Block6';

export default function Main() {
    window.scrollTo(0, 0);
    return (
        <>
         <Block1/>
         <Block2/>
         <Block3/>
         <Block4/>
         <Block5/>
         <Block6/>
        </>
    )
}
